import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  formItemWrapper: {
    ':hover': {
      ':not(#__unused__) > div > button > span': {
        display: 'flex',
      },
    },
  },
  container: {
    marginRight: `-32px`,
    ':hover': {
      ':not(#__unused__) > div': {
        outline: `1px solid ${colors.accentBorder}`,
      },
    },
  },
  containerDragging: {
    ':hover': {
      ':not(#__unused__) > div': {
        outline: 'none',
      },
    },
  },
  containerDraggedOver: {
    ':not(#__unused__) > div': {
      outline: `2px solid ${colors.accentBorder}`,
      outlineOffset: '2px',
      backgroundColor: colors.hoverBackground,
    },
  },
  content: {
    borderRadius: anatomy.borderRadiusM,
    padding: `${anatomy['size-20']} 74px`,
    marginRight: `32px`,
    position: 'relative',
  },
  removeButton: {
    display: 'none',
    padding: anatomy['size-4'],
    background: colors.accentBackground,
    borderRadius: anatomy.borderRadiusXs,
    position: 'absolute',
    right: -8,
    top: '50%',
    transform: 'translateX(100%) translateY(-50%)',
  },
  moveButton: {
    display: 'none',
    position: 'absolute',
    right: anatomy['size-4'],
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 10,
    cursor: 'grab',
  },
});
